import * as Sentry from '@sentry/react';
import React, { useReducer, useState, useCallback, useEffect, useMemo } from 'react';
import { Collapse, Paper } from '@mui/material';

import COLOR from 'utils/constants/color';
import styled from 'styled-components';
import { CaretDownOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { getAvatar } from 'utils/assets/images/lootie';
import { makeStyles } from 'utils/styles/mui';
import fiBrSearchSvg from "../../utils/assets/images/fi-br-search.svg";
import fiBulbSvg from "../../utils/assets/images/fi-bulb.svg";

const AVATAR_COLORS = [
    '#DF52D2', 
    '#FC6260', 
    '#3FD0FF', 
    '#f79835', 
    '#3FD0FF'
];


import { get, map, groupBy, find, filter } from "lodash";



import { AccountCircle, AttachFile } from '@mui/icons-material';
import NewMessageButton from './NewMessageButton';

;

import { sortMessage } from "utils/methods/math";

import moment from "moment";
import { useCurrentUser } from 'store/users/selectors';
import { getClassAvatar } from 'modules/parentsStudentHome/helper';




moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  })



const Wrapper = styled.div`
	width: 100%;
    height: 100%;
    align-item: center;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-height: 100vh;
     @media (max-width: 768px) {
       min-height: 100vh;
     }
`;
const UserList = styled.div`
    min-height: 56px;
    width: 100%;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    margin-bottom: 8px;
    background: ${props => props.active ? 'rgba(75, 156, 161, 0.08)' : 'transparent'};
    border: none;
    border-radius: 12px;
    color: #fff;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 12px;
    transition: all 0.2s ease;
    
    &:hover {
        background: ${props => props.active ? 'rgba(75, 156, 161, 0.12)' : 'rgba(0, 0, 0, 0.03)'};
        transform: translateX(4px);
    }
    
    &:active {
        transform: translateX(2px) scale(0.98);
    }
`;


const OnlineIndicater = styled.div`
    height:10px;
    width:10px;
    // background-color:${COLOR.green100};
    background-color: #44D824;
    border-radius: 50%;
    position: absolute;
    right: 0px;
    top: 0px;
`; 
const MessageTopArea = styled.div`ß
    border-top-left-radius: 20px;
    display:flex;
    flex-direction:row;
    // border-bottom:1px solid #a5a5a5;
`;
const UserArea = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding-top: 0px;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
        
        &:hover {
            background: rgba(0, 0, 0, 0.3);
        }
    }
`;
const OptionArea = styled.div`
    width: 100%;
    padding: 20px 15px 5px;
`;
const MessageText = styled.div`
    color: #000;
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

const ClassAnnouncment = styled.div`
    margin-bottom: 20px;
    width: 100%;
    align-self: center;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-transform: capitalize;
    text-overflow: ellipsis;
    color: #000;
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

const RecentHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    cursor: pointer;
    width: 100%;
    margin-bottom: 10px;
`;
const RecentHeaderText = styled.div`
    color: #000;
    font-family: Arial;
    padding-left: 18px;
    font-size: 14px;
    &:hover { 
        color: #6A6A6A;
        cursor: pointer;
    }
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
`;
const RecentHeaderIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    hover: {
        color: #6A6A6A;
        cursor: pointer;
    }
    color: #000;
    font-size: 16px;
    transition: transform 0.3s ease;
    transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
const UserRow = styled.div`
    display: flex;
    align-items: center;
    flex-direction:row;
    width:100%;
    gap: 10px;
    position: relative;

    @media (max-width: 432px) {
      gap: 5px;
    }
`;
const AvtarIconCol = styled.div`
    display: flex;
    align-items: center;
    width:17%;
    position:relative;
    @media (max-width: 992px) {
        width: auto;
        margin-right: 12px;
    }
`;
const AvtarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: ${props => props.bgColor || 'transparent'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
    
    &:hover {
        transform: scale(1.05);
    }
`;
const NameCol = styled.div`
    display: flex;
    align-items: center;
    width:83%;
    flex-direction:column;
    @media (max-width: 768px) { 
      width: 88%;
      margin-right: 12px;
    }  
`;
const NameInnerRow = styled.div`
    display: flex;
    width:100%;
    color: #fff;
    font-weight: bold;
    text-transform: capitalize;
`;
const NameText = styled.span`
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    color: #000;
    font-family: Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;
const TimeText = styled.span`
    font-size: 10px;
    width: 40%;
    color: #6A6A6A;
    text-align: right;
    font-family: Arial;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-wrap: nowrap;
}
`;
const MessageInnerRow = styled.div`
    display: block;
    width:100%;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-items:center;
    color: #6A6A6A;
    font-family: Arial;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;
const MessageCounterNotificationv = styled.span`
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0px;
    top: 40%;
    border-radius: 50%;
    font-size: 10px;
    text-align: center;
    background: red;
    overflow: hidden;
    display: flex;
    align-items:center;
    justify-content:center;
`;

const MessageNotificationRecentCount = styled.span`
    width: 20px;
    height: 20px;
    right: 0px;
    top: 40%;
    border-radius: 50%;
    font-size: 10px;
    text-align: center;
    background: red;
    overflow: hidden;
    display: flex;
    align-items:center;
    justify-content:center;
`;
const useStyles = makeStyles((theme) => ({
    bulbicon: {
        color: ' rgb(223 175 109)',
        fontSize: '18px',
        rotate: 'deg(180)',
        transform: 'rotate(180deg)',
        marginRight: '5px'
    },
    usericon: {
        color: 'rgb(255, 255, 255)',
        fontSize: '30px',
        marginRight: ' 5px'
    },
    usericonPopUp: {
        color: COLOR.gray100,
        fontSize: '30px',
        marginRight: ' 5px'
    },
    addIcon: {
        color: 'rgb(255, 255, 255)',
        fontSize: '20px',
        marginRight: ' 5px'
    },
    sendIcon: {
        color: 'rgb(255, 255, 255)',
        fontSize: '20px',
        marginRight: ' 5px'
    },
    fileIconWhite: {
        color: "#fff",
        fontSize: 10
    },
    fileIconGray: {
        color: COLOR.gray100,
        fontSize: 10
    },
    newMessageTitle: {
        marginTop: '0px',
        marginBottom: '20px',
        fontWeight: 700,
        textAlign: "center",
        fontSize: '20px',
        color: COLOR.black100,
        letterSpacing: '-0.5px'
    }
}));
//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------

const getTimeMessageTime = (messageTime) => {
    const dayDiff = moment().diff(moment(messageTime), "day");
    const weekDiff = moment().diff(moment(messageTime), "week");
    const monthDiff = moment().diff(moment(messageTime), "month");
    const yearDiff = moment().diff(moment(messageTime), "year")
    if (!messageTime) return null;
    if (dayDiff == 0) {
        const hourDiff = moment().diff(moment(messageTime), "hours")
        const minutDiff = moment().diff(moment(messageTime), "minutes")
        const secondDiff = moment().diff(moment(messageTime), "seconds")
        if (secondDiff > 15) {
            if (minutDiff > 59) {
                return `${hourDiff} hr`
            }
            return minutDiff > 0 ? `${minutDiff} min` : `${secondDiff} sec`;
        }
        return `Just now.`
    } else {
        if (dayDiff > 7) {
            if (weekDiff > 5) {
                if (monthDiff > 12) {
                    return `${yearDiff} y`
                }
                return `${monthDiff} m`
            }
            return `${weekDiff} w`
        }
        return `${dayDiff} d`
    }
}

// Helper function to get avatar background color based on user ID
const getAvatarColor = (userId) => {
    if (!userId) return AVATAR_COLORS[0];
    const index = Math.abs(userId.toString().split('').reduce((a, b) => a + b.charCodeAt(0), 0)) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
}
const Users = ({
    activeUser,
    activeClass,
    classes,
    selectedUser,
    setSelectedUser,
    chatMessages,
}) => {
   
    const currentUser = useCurrentUser();
    const cssClasses = useStyles();
    const [expendRecent, setExpendRecent] = useState(true)
    const [recentUserMessages, setRecentMessage] = useState([])
    const [filteredRecentMessages, setFilteredRecentMessages] = useState([])
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [unreadBrodCastMessage,setUnreadBrodcastmessage] = useState({})
    const isStudent = useMemo(() => get(currentUser, "role") === "student", [currentUser]);
    const currentUserId = useMemo(() => get(currentUser, "id"), [currentUser]);
    
    useEffect(() => {
        if (!chatMessages?.length || !currentUserId || !isStudent) {
            setUnreadBrodcastmessage({});
            return;
        }

        const brodcastMessage = groupBy(chatMessages, "brodcastId");
        const unreadCounts = Object.keys(brodcastMessage).reduce((acc, key) => {
            if (!key || key === "null") {
                return acc;
            }
            
            const unseenCount = filter(brodcastMessage[key], msg => {
                const hasSeen = find(msg.brodcastSeen, ["id", currentUserId]);
                return !hasSeen;
            }).length;
            
            if (unseenCount > 0) {
                acc[key] = unseenCount;
            }
            
            return acc;
        }, {});
        
        setUnreadBrodcastmessage(unreadCounts);
    }, [chatMessages, currentUserId, isStudent])
    useEffect(() => {
        const interval = setInterval(forceUpdate, 15000)
        return () => {
            clearInterval(interval)
        }
    }, [])
    const groupedMessages = useMemo(() => {
        if (!chatMessages?.length) return {};
        return {
            ...groupBy(chatMessages, "senderId"),
            ...groupBy(chatMessages, "receiverId"),
            ...groupBy(chatMessages, "brodcastId")
        };
    }, [chatMessages]);

    const activeClassId = useMemo(() => get(activeClass, "id"), [activeClass]);

    useEffect(() => {
        if (!chatMessages?.length || !activeUser?.length) {
            setRecentMessage([]);
            setFilteredRecentMessages([]);
            return;
        }

        const userMessagesData = Object.keys(groupedMessages)
            .map(key => {
                let usr = find(activeUser, ['id', key]);
                let isBrodcast = false;
                
                if (!usr) {
                    if (key !== activeClassId) return null;
                    usr = find(classes, ['id', key]);
                    if (!usr) return null;
                    isBrodcast = true;
                }

                const mData = isBrodcast
                    ? sortMessage(filter(chatMessages, c => c.brodcastId === key)).reverse()[0]
                    : sortMessage(filter(chatMessages, c => c.receiverId && (c.senderId === key || c.receiverId === key))).reverse()[0];
                
                const unseenCount = isBrodcast
                    ? 0
                    : filter(chatMessages, c => (c.senderId === key && c.receiverId && !c.seen)).length;

                return {
                    usr,
                    mData,
                    unseenCount
                };
            })
            .filter(Boolean)
            .sort((a, b) => {
                const dateA = get(a, "mData.createdAt");
                const dateB = get(b, "mData.createdAt");
                if (!dateA && !dateB) return 0;
                if (!dateA) return 1;
                if (!dateB) return -1;
                return new Date(dateB) - new Date(dateA);
            });

        setRecentMessage(userMessagesData);
        setFilteredRecentMessages(userMessagesData);
    }, [chatMessages, activeUser, groupedMessages, activeClassId, classes])
    useEffect(() => {
        if (get(currentUser, "role") !== "student") return;
        if (!selectedUser || !activeClass) return;
        if (get(selectedUser, "id") !== get(activeClass, "id")) return;

        setUnreadBrodcastmessage(prev => {
            const classId = get(activeClass, "id");
            if (!prev || !classId) return prev;
            const currentCount = prev[classId];
            if (currentCount === undefined || currentCount === null || currentCount === 0) {
                return prev;
            }
            return { ...prev, [classId]: 0 };
        });
    }, [selectedUser, activeClass, currentUser])


    const getUserIcon = useCallback((usr,popup) => {
        const avatar = getAvatar(get(usr, "config.avatar"))
        const classAvatar = getClassAvatar(get(usr, "id"),classes);
        return (avatar || classAvatar ? <Avatar size={23} src={avatar || classAvatar} /> : <AccountCircle className={popup?cssClasses.usericonPopUp:cssClasses.usericon} />)
    }, [cssClasses]);
    const RecenctRender = useCallback(() => {
        return (map(filteredRecentMessages, dt => {
            const usr = dt.usr
            const mData = dt.mData
            const unseenCount = dt.unseenCount
            const isBordcast = !get(usr, "username")
            return (<UserList className='availabUseList' key={get(usr, "id")} active={get(selectedUser, "id") === get(usr, "id")} onClick={() => setSelectedUser(usr)}>
                <UserRow>
                    <AvtarIconCol>
                        <AvtarContainer bgColor={getAvatarColor(get(usr, "id"))}>
                            {getUserIcon(usr)}
                            {usr.active && <OnlineIndicater />}
                        </AvtarContainer>
                    </AvtarIconCol>
                    <NameCol>
                        
                        <NameInnerRow>  
                            <NameText>{isBordcast ? `${get(usr, "displayName")} (announcement)` : `${get(usr, "lastName", "")},  ${get(usr, "firstName", "")}`} </NameText>
                            <div className="announcementTimeAndCount">
                                <TimeText>{getTimeMessageTime(get(mData, "createdAt"))} </TimeText> 
                                {unseenCount > 0 ? <MessageNotificationRecentCount>{unseenCount}</MessageNotificationRecentCount> : null}
                            </div>
                            
                        </NameInnerRow>
                        <MessageInnerRow> {mData ? get(mData, "type") == "media" ? <> {<AttachFile style={{ color: "#fff", fontSize: 10 }} />} Attachment  {get(mData, "message", "")} </> : get(mData, "message", "") : ''} </MessageInnerRow>
                    </NameCol>
                </UserRow>
            </UserList>)
        }))
    }, [filteredRecentMessages])
    const onSearchUser = (e) => {
        try {
            let txt = e.target.value ? e.target.value : '';
            if (txt && txt.length > 0) {
                txt = txt.toLowerCase().replace(/\s/g, '');
                const filteredRecent = filter(recentUserMessages, msgData => {
                    const usr = msgData.usr;
                    const lastName = get(usr, "lastName", "").toLowerCase().replace(/\s/g, '');
                    const firstName = get(usr, "firstName", "").toLowerCase().replace(/\s/g, '');
                    const username = get(usr, "username", "").toLowerCase().replace(/\s/g, '');
                    const displayName = get(usr, "displayName", "").toLowerCase().replace(/\s/g, '');
                    return lastName.includes(txt) || firstName.includes(txt) || username.includes(txt) || displayName.includes(txt);
                });
                setFilteredRecentMessages(filteredRecent);
            } else {
                setFilteredRecentMessages(recentUserMessages);
            }
        } catch (error) {
            Sentry.captureException(`451 Error during onSearchUser: ${error}`);
            setFilteredRecentMessages(recentUserMessages);
        }
    }
    return (
        <>
            <Wrapper className="msgSystemMdlMsg">

                <MessageTopArea className="msgSystemMdlTp">
                    <MessageText>OneWayMessaging</MessageText>
                    {/* <MessageTopIcon><AVatarSelector size={40} /></MessageTopIcon>  */}
                </MessageTopArea>

                <UserArea className="msgSystemMdlusr2">
                    <RecentHeader onClick={() => { setExpendRecent(!expendRecent) }}>
                        <RecentHeaderText>Recent</RecentHeaderText>
                        <RecentHeaderIcon isExpanded={expendRecent}>
                            <CaretDownOutlined />
                        </RecentHeaderIcon>
                    </RecentHeader>
                    <Collapse in={expendRecent} style={{ background: "transparent" }}>
                        <Paper elevation={0} style={{ background: "transparent" }}>
                            {RecenctRender()}
                        </Paper>
                    </Collapse>
                </UserArea>

                <div className="msgSystemUprstm ">
                    <div className='msgUsrSearch'>
                      <div className='msgUsrSearchInr'>
                       <img src={fiBrSearchSvg} alt="" title="" />
                        <input type='text' placeholder='Search' onChange={onSearchUser} />
                     </div>
                   </div>
                  <OptionArea className="msgSystemMdlOpn">
                    <NewMessageButton
                        activeUser={activeUser}
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                    />
                    <ClassAnnouncment onClick={() => setSelectedUser(activeClass)}>
                        {/* <WbIncandescent className={cssClasses.bulbicon} />  */}
                         <div className='msgSystemNewIcons'>
                          <img src={fiBulbSvg} alt="Class Announcement" title="Class Announcement" />
                         </div>Class Announcement
                         {unreadBrodCastMessage[get(activeClass,"id")] > 0 ? <MessageCounterNotificationv style={{backgroundColor:COLOR.red, position:"relative",marginLeft:10}}>{unreadBrodCastMessage[get(activeClass,"id")]}</MessageCounterNotificationv> : null}
                        
                    </ClassAnnouncment>
                  </OptionArea>
                </div>  

            </Wrapper>
        </>
    );
};


export default Users;